import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'quantidadePlural'
})
export class QuantidadePluralPipe implements PipeTransform {
    transform(value: number, arg: string): string {
        if (value == 0) {
            if (arg == 'de compra' || arg == 'de matéria prima' || arg == 'de material secundário' || arg == 'de outros materiais')
                return `nenhuma ordem ${arg}`;

            if (arg == 'pedido')
                return `nenhum ${arg}`;

            return `nenhuma ${arg}`;
        }
        else if (arg == 'de compra' || arg == 'de matéria prima' || arg == 'de material secundário' || arg == 'de outros materiais') {
            if (value > 1)
                return `${value.toLocaleString('pt-BR')} ordens ${arg}`;

            return `${value.toLocaleString('pt-BR')} ordem ${arg}`;
        }
        else if (value > 1 && arg != 'moda praia')
            return `${value.toLocaleString('pt-BR')} ${arg}s`;

        return `${value.toLocaleString('pt-BR')} ${arg}`;
    }
}


// WEBPACK FOOTER //
// ./src/pipes/quantidade-plural.ts